'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/6/24.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Collapse from 'react-collapse';
// import { Link } from 'react-router';

var ProductListFilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProductListFilterBar, _Component);

  function ProductListFilterBar() {
    (0, _classCallCheck3.default)(this, ProductListFilterBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ProductListFilterBar).call(this));

    _this.secondChildren = [];
    _this.thirdChildren = [];
    _this.state = {
      activeFirstChild: '',
      activeSecondChild: ''
    };
    return _this;
  }

  (0, _createClass3.default)(ProductListFilterBar, [{
    key: 'analysisThirdChildren',
    value: function analysisThirdChildren(children, parentId) {
      var styles = require('./ProductListFilterBar.scss');
      var thirdChildren = this.thirdChildren;

      var newThirdChildren = [].concat((0, _toConsumableArray3.default)(thirdChildren));
      var allChildren = [];
      if (children instanceof Array) {
        children.forEach(function (currentChild) {
          if (allChildren.findIndex(function (child) {
            return child.id === currentChild.id;
          }) < 0) {
            allChildren.push({
              id: currentChild.id,
              content: _react2.default.createElement(
                'span',
                { key: currentChild.id, className: styles.firstChild },
                ' ' + currentChild.text
              )
            });
          }
        });
        newThirdChildren.push({
          parentId: parentId,
          allChildren: allChildren
        });
      }
      this.thirdChildren = newThirdChildren;
    }
  }, {
    key: 'analysisSecondChildren',
    value: function analysisSecondChildren(children, parentId) {
      var _this2 = this;

      var styles = require('./ProductListFilterBar.scss');
      var secondChildren = this.secondChildren;

      var newSecondChildren = [].concat((0, _toConsumableArray3.default)(secondChildren));
      var allChildren = [];
      if (children instanceof Array) {
        children.forEach(function (currentChild) {
          if (allChildren.findIndex(function (child) {
            return child.id === currentChild.id;
          }) < 0) {
            _this2.analysisThirdChildren(currentChild, currentChild.id);
            allChildren.push({
              id: currentChild.id,
              content: _react2.default.createElement(
                'span',
                { key: currentChild.id, className: styles.firstChild },
                ' ' + currentChild.text
              )
            });
          }
        });
        newSecondChildren.push({
          parentId: parentId,
          allChildren: allChildren
        });
      }
      this.secondChildren = newSecondChildren;
    }
  }, {
    key: 'analysisSecondShownChildren',
    value: function analysisSecondShownChildren(children, parentId) {
      var _this3 = this;

      var styles = require('./ProductListFilterBar.scss');
      var query = this.props.query;

      var allChildren = [];
      var thirdAllChildren = '';
      if (children instanceof Array) {
        children.forEach(function (currentChild) {
          if (allChildren.findIndex(function (child) {
            return child.id === currentChild.id;
          }) < 0) {
            var currentClass = styles.firstChild;
            if (query[parentId] === currentChild.id) {
              thirdAllChildren = _this3.analysisThirdShownChild(currentChild.children);
              currentClass = currentClass + ' ' + styles.active;
            }
            allChildren.push(_react2.default.createElement(
              'span',
              { key: currentChild.id,
                onClick: function onClick() {
                  return _this3.firstChildrenClick(currentChild.id, currentChild.field);
                },
                className: currentClass },
              ' ' + currentChild.text
            ));
          }
        });
      }
      return {
        secondChildren: allChildren,
        thirdChildren: thirdAllChildren
      };
    }
  }, {
    key: 'analysisThirdShownChild',
    value: function analysisThirdShownChild(children) {
      var _this4 = this;

      var styles = require('./ProductListFilterBar.scss');
      var allChildren = [];
      if (children instanceof Array) {
        children.forEach(function (currentChild) {
          if (allChildren.findIndex(function (child) {
            return child.id === currentChild.id;
          }) < 0) {
            allChildren.push(_react2.default.createElement(
              'span',
              { key: currentChild.id,
                onClick: function onClick() {
                  return _this4.firstChildrenClick(currentChild.id, currentChild.field);
                },
                className: styles.firstChild },
              ' ' + currentChild.text
            ));
          }
        });
      }
      return allChildren;
    }
  }, {
    key: 'firstChildrenClick',
    value: function firstChildrenClick(firstId, key) {
      var itemClick = this.props.itemClick;

      if (itemClick) {
        itemClick(firstId, key);
      }
    }
  }, {
    key: 'analysisFirstChildren',
    value: function analysisFirstChildren(children, parentId, filterName) {
      var _this5 = this;

      var styles = require('./ProductListFilterBar.scss');
      var query = this.props.query;

      var currentContent = '';
      var childrenDiv = {};
      if (children instanceof Array) {
        currentContent = children.map(function (currentChild) {
          _this5.analysisSecondChildren(currentChild.children, currentChild.id);
          var currentClass = styles.firstChild;
          if (query[parentId] === currentChild.id) {
            currentClass = currentClass + ' ' + styles.active;
            childrenDiv = _this5.analysisSecondShownChildren(currentChild.children, currentChild.id, filterName);
          }
          return _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                return _this5.firstChildrenClick(currentChild.id, currentChild.field);
              }, key: currentChild.id,
              className: currentClass },
            ' ' + currentChild.text
          );
        });
      }
      return (0, _extends3.default)({
        currentContent: currentContent
      }, childrenDiv);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var styles = require('./ProductListFilterBar.scss');
      var treeData = this.props.treeData;

      var content = _react2.default.createElement('div', null);
      if (treeData && treeData.root instanceof Array) {
        content = treeData.root.map(function (data) {
          var resultDiv = _this6.analysisFirstChildren(data.children, data.id, data.text);
          return _react2.default.createElement(
            'div',
            { key: data.id },
            _react2.default.createElement(
              'span',
              {
                className: styles.title },
              data.text
            ),
            _react2.default.createElement('br', null),
            resultDiv.currentContent,
            _react2.default.createElement('br', null),
            resultDiv.secondChildren && resultDiv.secondChildren instanceof Array && resultDiv.secondChildren.length > 0 ? _react2.default.createElement(
              'div',
              { className: styles.secondChildren },
              resultDiv.secondChildren
            ) : '',
            resultDiv.thirdChildren && resultDiv.thirdChildren instanceof Array && resultDiv.thirdChildren.length > 0 ? _react2.default.createElement(
              'div',
              null,
              resultDiv.thirdChildren
            ) : ''
          );
        });
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        content
      );
    }
  }]);
  return ProductListFilterBar;
}(_react.Component), _class.propTypes = {
  treeData: _react.PropTypes.object.isRequired,
  activeFirstChild: _react.PropTypes.string,
  activeSecondChild: _react.PropTypes.string,
  query: _react.PropTypes.object,
  itemClick: _react.PropTypes.func
}, _temp);
exports.default = ProductListFilterBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProductListFilterBar/ProductListFilterBar.js
 ** module id = 1410
 ** module chunks = 0
 **/